/**
 * Per-axis data the store_offer index ships so search surfaces can render
 * per-axis UI without a second query (issue #55186). Built by PHP
 * AlgoliaStoreOfferHandler::buildAxisValues; consumed by <AxisValueSuffix>.
 */

export interface AxisValueEntry {
   value: string;
   raw_value: string;
   price_from: number | null;
   variant_count: number;
}

export interface AxisValue {
   axis_code: string;
   values: AxisValueEntry[];
}

// condition_code "0" is the default "New" -- noise on every card, so suppress it.
const SUPPRESSED_VALUES = new Set(['condition_code:0']);

/**
 * Joins each axis's display value with ' / ' in the order PHP emits them (split
 * axes lead). Returns null when nothing is left to show so callers can skip the
 * title suffix entirely. Consumed by the search surfaces that fold the axis of
 * variation into the product title (issue #55186).
 */
export function formatAxisValues(axisValues?: AxisValue[] | null): string | null {
   const labels = (axisValues ?? []).flatMap(axis => {
      const value = axis.values[0];
      if (!value || SUPPRESSED_VALUES.has(`${axis.axis_code}:${value.raw_value}`)) {
         return [];
      }
      return value.value;
   });

   return labels.length === 0 ? null : labels.join(' / ');
}
